import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IPaymentReviewSummary } from "./paymentReviewSummary.types"
import { PaymentReviewSummary } from "./paymentReviewSummary"
import { GetPaymentReviewSummaryQuery } from "@/api/hasura/generated/graphql"

export type PaymentReviewSummaryRaw = GetPaymentReviewSummaryQuery

export const PaymentReviewSummaryParser: IParser<
  IPaymentReviewSummary,
  PaymentReviewSummaryRaw
> = {
  toDomain: (data: PaymentReviewSummaryRaw): IPaymentReviewSummary => {
    try {
      const completed = data.completed?.aggregate?.count
      const failed = data.failed?.aggregate?.count
      const skipped = data.skipped?.aggregate?.count
      const total = data.total?.aggregate?.count

      if (
        completed === undefined ||
        failed === undefined ||
        skipped === undefined ||
        total === undefined
      ) {
        throw new Error("PaymentReviewSummaryParser: toDomain: invalid data")
      }

      return new PaymentReviewSummary(completed, failed, skipped, total)
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
